import { FunctionComponent, useEffect, useRef } from "react";
import styles from "./heat.module.css";
import { Data } from "@/api/fetchCoverage";
import mapLoader from "@/utils/other/mapLoader";
import { MAP_STYLES } from "@/components/Map/help/constants";

type Props = {
  coverage: Data["coverage"];
  lat: number;
  lng: number;
  zoom?: number;
  aspectRatio?: number;
};

const MapHeat: FunctionComponent<Props> = ({
  coverage,
  aspectRatio = 9 / 16,
  lat,
  lng,
  zoom = 13,
}) => {
  const map = useRef<null>(null);
  const percent = aspectRatio * 100;

  useEffect(() => {
    if (map.current)
      mapLoader().then((google: any) => {
        const mapOptions = {
          center: {
            lat,
            lng,
          },
          zoom,
          styles: MAP_STYLES,
          mapTypeControl: false,
          scaleControl: false,
          streetViewControl: false,
          rotateControl: false,
          fullscreenControlOptions: {
            position: google.maps.ControlPosition.LEFT_TOP,
          },
        };

        const heatMapData = coverage.map((v) => ({
          location: new google.maps.LatLng(v.gps.lat, v.gps.lon),
          weight: v.weight,
        }));

        const googleMap = new google.maps.Map(map.current, mapOptions);

        const heatmap = new google.maps.visualization.HeatmapLayer({
          data: heatMapData,
        });

        heatmap.setMap(googleMap);
      });
  }, [map, zoom]);

  return (
    <div className={styles.item}>
      <div className={styles.aspect} style={{ paddingBottom: `${percent}%` }} />
      <div className={styles.map} ref={map} />
    </div>
  );
};

export default MapHeat;
